import { styled, Box } from "@mui/material";

export const StyledImage = styled(Box)({
  width: "100%",
  height: 100,
  objectFit: "contain",
}) as typeof Box;
